import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { notes } from '../services/user'

const initialState = {
  
  SessionID: null,
  PageID: null,

}

export const fetchInsert_SessionID = createAsyncThunk(
  'fetchInsert_SessionID',
  async (Insert_SessionID, thunkAPI) => {
    Insert_SessionID = { ...Insert_SessionID, elasticQueryName: "Insert_SessionID" }
    const Get_SessionID = { ...Insert_SessionID, elasticQueryName: "Get_SessionID" }
    const response = await notes(Insert_SessionID);
    if (response.status == 200) {
      const response =  await notes(Get_SessionID);
      const [data] = response.data ?? [];
      return data ?? {}
    }
    return {}
  }
)

export const fetchUpdate_SessionID = createAsyncThunk(
  'fetchUpdate_SessionID',
  async (Update_SessionID, thunkAPI) => {
    Update_SessionID = { ...Update_SessionID, elasticQueryName: "Update_SessionID" }
    const response = await notes(Update_SessionID);
    return response.data
  }
)

export const fetchPage_id = createAsyncThunk(
  'fetchPage_id',
  async (Page_id, thunkAPI) => {
    Page_id = { ...Page_id, elasticQueryName: "Page_id" }
    const response = await notes(Page_id);
    const [data] = response.data ?? []
    return data ?? {}
  }
)

export const fetchInsert_UsageMetrics = createAsyncThunk(
  'fetchInsert_UsageMetrics',
  async (Insert_UsageMetrics, thunkAPI) => {
    Insert_UsageMetrics = { ...Insert_UsageMetrics, elasticQueryName: "Insert_UsageMetrics" }
    const response = await notes(Insert_UsageMetrics);
    return response.data
  }
)

export const fetchUpdate_UsageMetrics = createAsyncThunk(
  'fetchUpdate_UsageMetrics',
  async (Update_UsageMetrics, thunkAPI) => {
    Update_UsageMetrics = { ...Update_UsageMetrics, elasticQueryName: "Update_UsageMetrics" }
    const response = await notes(Update_UsageMetrics);
    return response.data
  }
)


export const User = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      return {
        ...state,
        ...action.payload
      }
    }
  },
  extraReducers: (builder) => {

    builder.addCase(fetchInsert_SessionID.fulfilled, (state, action) => {
      state.SessionID = (action.payload).SESSION_ID ?? null;
    }).addCase(fetchInsert_SessionID.pending, (state, action) => {
      // state.Insert_SessionIDloading = true;
    })

    builder.addCase(fetchPage_id.fulfilled, (state, action) => {
      state.PageID = (action.payload).PAGE_ID ?? null;
    }).addCase(fetchPage_id.pending, (state, action) => {
      state.PageID = null;
    })

  }

})

// Action creators are generated for each case reducer function
export const { setUserData } = User.actions

export default User.reducer